import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { autoinject } from "aurelia-dependency-injection";
import { Router } from "aurelia-router";

@autoinject
export class DialogNoSeniorApproval {
    
    constructor(private dialogClientService:DialogClientService, private router:Router) {}
    
    //setup
    public setup() {
        this.router.navigateToRoute("settings", {tab: "DueDiligenceConfiguration"} );
    }

    //Close dialog
    public close() {
        this.dialogClientService.hide();
    }
}